import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import TerminalTyping from "./TerminalTyping";
import "./Hero.css";

const Hero = ({ hasEntered }) => {
  const [showTerminal, setShowTerminal] = useState(false);
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  const terminalCommands = [
    "whoami",
    "user",
    'echo "GHALI Faiçal - Full Stack Developer"',
    "GHALI Faiçal - Full Stack Developer",
    "ls -la skills/",
    `total 16
drwxr-xr-x  3 user user 4096 Nov  8 12:00 .
drwxr-xr-x 15 user user 4096 Nov  8 12:00 ..
-rw-r--r--  1 user user   31 Nov  8 12:00 frontend.txt
-rw-r--r--  1 user user   28 Nov  8 12:00 backend.txt
-rw-r--r--  1 user user   28 Nov  8 12:00 mobile.txt
-rw-r--r--  1 user user   28 Nov  8 12:00 devops.txt`,
    "cat skills/frontend.txt",
    "React, TypeScript, Next.js, Tailwind CSS",
    "cat skills/backend.txt",
    "Node.js, Express, Laravel, Spring Boot",
    "cat skills/mobile.txt",
    "React Native",
    "cat skills/devops.txt",
    "Docker, Git",
    'echo "Building scalable web applications!"',
    "Building scalable web applications!",
  ];

  useEffect(() => {
    if (inView && hasEntered) {
      const timer = setTimeout(() => setShowTerminal(true), 1000);
      return () => clearTimeout(timer);
    }
  }, [inView, hasEntered]);

  const handleContactClick = (event) => {
    event.preventDefault();
    const target = document.querySelector("#contact");
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.3,
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.5,
      },
    },
  };

  return (
    <section id="hero" className="hero" ref={ref}>
      <motion.div
        className="hero-content"
        variants={containerVariants}
        initial="hidden"
        animate={inView ? "visible" : "hidden"}
      >
        <motion.div className="hero-terminal" variants={itemVariants}>
          <div className="terminal-window">
            <div className="terminal-header">
              <div className="terminal-buttons">
                <span className="terminal-button red"></span>
                <span className="terminal-button yellow"></span>
                <span className="terminal-button green"></span>
              </div>
              <div className="terminal-title">bash</div>
            </div>
            <div className="terminal-body">
              {showTerminal && <TerminalTyping commands={terminalCommands} />}
            </div>
          </div>
        </motion.div>
        <motion.div className="hero-text" variants={itemVariants}>
          <div className="hero-heading">
            <h1>
              Hi, I'm <span>GHALI Faiçal</span>
            </h1>
            <p className="subtitle">A Full Stack Developer</p>
          </div>
          <div className="hero-details">
            <p className="description">
              I specialize in building (and occasionally designing) exceptional
              digital experiences. Currently, I'm focused on building
              accessible, human-centered products.
            </p>
            <div className="hero-buttons">
              <a
                href="#contact"
                className="hero-cta"
                onClick={handleContactClick}
              >
                Get in Touch
              </a>
              <a
                href="/CV-Ghali-Faiçal.pdf"
                className="hero-cta secondary"
                download="CV-Ghali-Faiçal.pdf"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3" />
                </svg>
                Download CV
              </a>
            </div>
          </div>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Hero;
